import React from "react";
import { Link } from "react-router-dom";
import { useUser } from "../Hook/useUser";
import redLogo from "../assets/images/logo-parlons-regles.png";
import PropTypes from "prop-types";

function NavbarUser({ closeModal, bColor }) {
	const { user, updateUser } = useUser();

	const update = (value) => {
		updateUser(value);
	};

	const handleClick = (clickedUser) => {
		update(clickedUser);
		if (closeModal) {
			closeModal();
		}
	}

	return (
		<div
			className="navbar__navbar-user-container"
			style={{ backgroundColor: bColor }}
		>
			<div className="navbar__logo-container">
				<Link
					to={
						user === "young"
							? "/"
							: user === "parent"
							? "/Parents"
							: "/Relais"
					}
				>
					<img
						className="navbar__logo"
						src={redLogo}
						alt="Parlons règles par Règles Élémentaires"
					/>
				</Link>
			</div>
			<div className="navbar__navbar-user-link-container">
				<nav className="navbar__navbar-user-nav">
					<p
						className="navbar__navbar-who"
					>
						Je suis :
					</p>
					{user !== "young" && (
						<Link
							className="navbar__navbar-user-link focused"
							key={0}
							onClick={() => handleClick("young")}
							to="/"
						>
							Jeune
						</Link>
					)}
					{user !== "parent" && (
						<Link
							className="navbar__navbar-user-link focused"
							key={1}
							onClick={() => handleClick("parent")}
							to="/Parents"
						>
							Parent
						</Link>
					)}
					{user !== "relai" && (
						<Link
							className="navbar__navbar-user-link focused"
							key={2}
							onClick={() => handleClick("relai")}
							to="/Relais"
						>
							Relais éducatifs
						</Link>
					)}
				</nav>
			</div>
		</div>
	);
}

NavbarUser.propTypes = {
	bColor: PropTypes.string,
};

export default NavbarUser;
